import { EditIcon, SearchIcon } from 'lucide-react';
import React, { useState } from 'react';
import { MdEdit } from "react-icons/md";

const InterestLocation = ({
  locations,
  onCreate,
  onUpdate,
  maxLocations,
  disableInput,
  loading,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [editingLocation, setEditingLocation] = useState(null);
  const [search , setSearch] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleAddOrUpdate = () => {
    if (editingLocation) {
      onUpdate(editingLocation.id, inputValue);
      setEditingLocation(null);
    } else {
      onCreate(inputValue);
    }
    setInputValue('');
  };

  const handleEdit = (location) => {
    setEditingLocation(location);
    setInputValue(location.name);
  };

  const handleCancel = () => {
    setEditingLocation(null);
    setInputValue('');
  };

  

  const filteredTags = locations.filter(location =>
    location.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="mb-8">
      {/* Header and count */}
      
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
       <div className="flex flex-col md:flex-row justify-between items-center gap-4">
         <div className="flex flex-col md:flex-row items-center gap-4 w-full md:w-auto">
           <h1 className="text-xl font-bold text-gray-800">Interest Location</h1>
          <div className="relative w-full md:w-64">
          <input
             type="text"
             value={search}
             onChange={(e) => setSearch(e.target.value)}
             placeholder="Search locations"
             className="px-4 py-2 w-full md:w-64 text-sm rounded-lg border border-gray-300 input-focus"
           />
           <SearchIcon className="absolute right-3 top-[9px]  text-gray-300 w-5 h-5" />
          </div>
         </div>
         <div className="flex flex-col items-center md:items-end gap-1">
           <span
             className={`text-sm font-medium ${
              locations.length >= maxLocations * 0.8 ? 'text-red-500' : 'text-gray-500'
             }`}
           >
             {locations.length}/{maxLocations} Locations Tags used
           </span>
        
           <div className="w-36 bg-gray-200 h-2 rounded-full overflow-hidden">
             <div
               className={`h-2 rounded-full ${
                locations.length >= maxLocations * 0.8 ? 'bg-red-500' : 'bg-customGreen'
               }`}
               style={{ width: `${(locations.length / maxLocations) * 100}%` }}
             ></div>
           </div>
         </div>
       </div>
     </div>

      {/* Locations and input */}
      <div className="flex gap-16 mt-4">
        {/* Existing locations */}
        <div className="custom-scrollbar overflow-x-hidden flex flex-wrap flex-auto w-7/12 h-64 rounded-md p-3 gap-x-2 gap-y-2 bg-appGrayBackground overflow-y-auto">
          {filteredTags.map((item) => (
            <div
              key={item.id}
              className="bg-customGreen capitalize h-8 rounded-lg px-3 text-sm font-normal text-white mr-2 mb-2 flex items-center"
            >
              <span>{item.name}</span>
              <button
                className="ml-2 focus:outline-none"
                onClick={() => handleEdit(item)}
               
              >
                <MdEdit className="w-4 h-4 text-white" />
              </button>
            </div>
          ))}
        </div>

        {/* Input and actions */}
        <div className="flex flex-col w-5/12">
          <div className="flex gap-4 items-start">
            <div className="flex flex-col gap-1 max-w-md w-full">
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                maxLength={50}
                placeholder="Enter interest location"
                className="px-4 py-2 h-10 text-sm rounded-md border border-gray-300 input-focus"
                disabled={disableInput && !editingLocation}
              />
              <div className="text-sm text-gray-500 mt-2">
                Add locations like: Chennai, Tambaram, Bangalore, Delhi, etc.
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={handleAddOrUpdate}
                disabled={(disableInput && !editingLocation) || loading}
                className={`h-10 px-4 text-sm font-medium rounded-md transition duration-200 ${
                  loading
                    ? 'text-gray-400 bg-gray-200 cursor-not-allowed'
                    : disableInput && !editingLocation
                    ? 'text-red-400 bg-red-100 cursor-not-allowed'
                    : 'text-white bg-customGreen'
                }`}
              >
                {loading ? 'Loading...' : editingLocation ? 'Update' : 'Add'}
              </button>

              {editingLocation && (
                <button
                  onClick={handleCancel}
                  className="h-10 px-4 text-sm font-medium rounded-md transition duration-200 text-white bg-gray-500 hover:bg-gray-600"
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestLocation;
